import React from "react";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

import "../../Styles/app.css";
import "./Styles/style.css";
import "./Styles/theme-responsive.css";
import { connect } from "react-redux";
import { saveRegistrationInfo, showModal, hideModal, setHelpList } from "../../../common/actions/userAccount";
import { BootstrapModal } from "../../CommonComponents";
import GLOBAL_CONST from '../../../helper/AppConstants';
import { nextField } from "../../../helper/utility";

import {
  RegisterFooter,
  RegisterHeader,
  RegisterWizard,
  SubmitButton,
} from "../../CommonComponents";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import { withTranslation } from "react-i18next";
import { createLoadingSelector } from "../../../common/reducers/selectors";
const loadingSelector = createLoadingSelector(["register_password"]);


class RegisterPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: null,
      repeatPassword: null,
      passwordStrength: "",
      passwordInvalid: "",
      confirmError: "",
      termsAccepted: false,
      hidePassword: true,
      hideConfirmPassword: true,
      termAcceptError: ""
    };
    this.dosetHelpList()
  }

  componentDidMount() {
    this.dosetHelpList()

  }
  dosetHelpList = () => {
    this.props.dosetHelpList({
      stackType: "Registration",
      screen: GLOBAL_CONST.SCREEN_NAMES.REGISTRATION_PASSWORD,
      title: this.props.t('regCardScr-regAccount'),
    });
  }
  openHelpModal = () => {
    this.props.doShowModal({
      modalScreenName: "HelpListing",
      modalClassName: "helpSupportModal sidebar-modal right",
      params: {
        stackType: this.props.setHelpListData.stackType,
        screen: this.props.setHelpListData.screen,
        title: this.props.setHelpListData.title,
      }
    });
  }

  acceptTermAndCondition = () => {
    this.setState({ termsAccepted: !this.state.termsAccepted });
  };
  setPasswordVisibility = () => {
    this.setState({ hidePassword: !this.state.hidePassword });
  };

  setConfirmPasswordVisibility = () => {
    this.setState({ hideConfirmPassword: !this.state.hideConfirmPassword });
  };
  handlePassword = (event) => {
    const rating = [
      0,
      "Weak",
      25,
      "Medium",
      50,
      "Good",
      75,
      "Strong",
      100,
      "Very Strong",
    ];

    let score = 0;
    let pass = "";
    if (event.target.value.length > 8 && event.target.value.match(/[0-9]/)) {
      score += 25;
    }
    if (
      event.target.value.length > 4 &&
      event.target.value.match(/[a-z]/) &&
      event.target.value.match(/[A-Z]/)
    ) {
      score += 25;
    }
    if (event.target.value.match(/[\!\@\#\$\%\^\&\*\?\_\~\-\(\)]+/)) {
      score += 25;
    }
    for (let i = rating.length - 1; i >= 0; i -= 1) {
      if (score >= rating[i]) {
        pass = rating[i + 1];
        break;
      }
    }

    this.setState({
      passwordStrength: pass,
      password: event.target.value,
      passwordInvalid: "",
    });
  };
  secondTextInput(event) {
    const form = event.target.form;
    const index = Array.prototype.indexOf.call(form, event.target);
    if (event.key === 'Enter') {
      form.elements[index + 1].focus();
    }
  }
  handleConfirmPassword = (e) => {
    this.setState({
      repeatPassword: e.target.value,
      confirmError: "",
    });
  };
  handletermAccespted = (e) => {
    this.setState({ termsAccepted: e.target.checked, termAcceptError: "" });
  };
  renderPasswordString = () => {
    const { password, passwordStrength } = this.state;
    if (password !== "") {
      if (passwordStrength === "Weak") {
        return <span className="error">{this.props.t("regPwdScr-weak")}</span>;
      }
      if (passwordStrength === "Good") {
        return (
          <span className="orange-text">{this.props.t("regPwdScr-good")}</span>
        );
      }
      if (passwordStrength === "Medium") {
        return (
          <span className="orange-text">
            {this.props.t("regPwdScr-medium")}
          </span>
        );
      }
      if (passwordStrength === "Strong" || passwordStrength === "Strong") {
        return (
          <span className="green-text">{this.props.t("regPwdScr-strong")}</span>
        );
      }
    }
    return <span>-</span>;
  };

  submitForm = () => {
    const { password, repeatPassword, termsAccepted } = this.state;
    const { doSaveRegistrationInfo } = this.props;
    if (password === null || password.length <= 5) {
      this.setState({
        passwordInvalid: this.props.t("regPwdScr-pwdInvalid"),
      });
      return;
    }
    if (password !== repeatPassword) {
      this.setState({
        confirmError: this.props.t("regPwdScr-pwdNotMatch"),
      });
      return;
    }

    if (!termsAccepted) {
      this.setState({
        termAcceptError: this.props.t("regPwdScr-please-accept-termsCondition"),
      });
      return;
    }

    doSaveRegistrationInfo({ registeredPassword: password });
    this.props.history.push("/registerSuccess");
  };

  render() {
    const {
      hidePassword,
      hideConfirmPassword,
      password,
      repeatPassword,
      passwordInvalid,
      confirmError,
      termsAccepted,
      termAcceptError,
    } = this.state;
    const { isFetching } = this.props;
    return (
      <section className="registration">
        <div className="wrapper">
          <div className="landing-wrapper">
            <div className="row h-100vh nomargin-row">
              <RegisterHeader />
              <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
                <div className="sidebar-wrapper">
                  <form className="form-style1">
                    <RegisterWizard webPage={this.props.location.pathname} />
                    <div className="title-sect mb-40">
                      <h3 className="title-3">
                        {this.props.t("regPwdScr-passwordTitle")}
                      </h3>
                      <p className="helptext">
                        {this.props.t("regPwdScr-passwordDescript")}
                      </p>
                    </div>
                    <div className="form-group">
                      <input
                        type={hidePassword ? "password" : "text"}
                        className={`form-control ${passwordInvalid !== "" ? "input-error" : null
                          }`}
                        placeholder={this.props.t("regPwdScr-enterPassword")}
                        value={password}
                        onChange={this.handlePassword}
                        name="password"
                        maxLength={16}
                        onKeyPress={(event)=>nextField(event)}
                      />
                      <i
                        onClick={this.setPasswordVisibility}
                        className={
                          hidePassword
                            ? "far fa-eye togglePassword"
                            : "far fa-eye-slash togglePassword1"
                        }
                      ></i>
                      <span className="error" id="message">
                        {" "}
                        {passwordInvalid}
                      </span>
                    </div>

                    <div className="form-group">
                      <input
                        type={hideConfirmPassword ? "password" : "text"}
                        className={`form-control ${confirmError !== "" ? "input-error" : null
                          }`}
                        placeholder={this.props.t("regPwdScr-confirmPassword")}
                        value={repeatPassword}
                        onChange={this.handleConfirmPassword}
                        maxLength={16}
                        onKeyPress={(event)=>{if (event.key === 'Enter') this.submitForm();}}
                      />
                      <i
                        onClick={this.setConfirmPasswordVisibility}
                        className={
                          hideConfirmPassword
                            ? "far fa-eye togglePassword"
                            : "far fa-eye-slash togglePassword1"
                        }
                      ></i>

                      <span className="error" id="message">
                        {confirmError != ""
                          ? confirmError
                          : termAcceptError != ""
                            ? termAcceptError
                            : null}
                      </span>
                    </div>
                    <div className="form-group">
                      <p className="font-sm pass-check">
                        {this.props.t("regPwdScr-strength")}:
                        {this.renderPasswordString()}{" "}
                      </p>
                    </div>
                    <div className="form-group mb-40">
                      <div className="accept-terms-label">
                        <div className="box-checkbox">
                          <input
                            type="checkbox"
                            id="accept_terms"
                            name="accept_terms"
                            value={termsAccepted}
                            onChange={this.handletermAccespted}
                          />
                          <label htmlFor="accept_terms"></label>
                          <span className="label-text">
                            {this.props.t("regPwdScr-accept")}{" "}
                            <a href="https://www.pikmykid.com/mobile-terms/"
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                              {this.props.t("regPwdScr-termsCondition")}
                            {" "}
                            &amp;{" "}
                            
                              {this.props.t("regPwdScr-privacyPolicy")}
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <button type="button" className="btn needhelp-label"
                        onClick={() => {
                          this.openHelpModal();
                        }}

                      >
                        {this.props.t("regNameScr-needHelp")}
                      </button>
                    </div>
                    <SubmitButton
                      nextAction={() => {
                        this.submitForm();
                      }}
                    loading={isFetching}

                    />
                  </form>
                  <RegisterFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    registeredPassword: state.userAccount.registeredPassword,
    setHelpListData: state.userAccount.setHelpListData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doSaveRegistrationInfo: (data) => dispatch(saveRegistrationInfo(data)),
    dosetHelpList: (data) => dispatch(setHelpList(data)),
    doShowModal: (data) => dispatch(showModal(data)),
    doHideModal: () => dispatch(hideModal()),



  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterPassword)
);
